var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailErrorIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4054_7353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.741 50.0703C100.741 22.4561 78.3554 0.0703125 50.7412 0.0703125C23.127 0.0703125 0.741211 22.4561 0.741211 50.0703C0.741211 77.6845 23.127 100.07 50.7412 100.07C78.3554 100.07 100.741 77.6845 100.741 50.0703Z",
    fill: "#ECF1F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0135 42.7773L54.0232 53.9409C52.4343 55.05 49.8353 55.05 48.247 53.9409L32.256 42.7773H29V69.044H72.6213V42.7773H70.0135Z",
    fill: "#F0C330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9866 37.0508H32.6348C30.6351 37.0508 29 38.6866 29 40.6856V65.4047C29 67.4043 30.6358 69.0395 32.6348 69.0395H68.9866C70.9855 69.0395 72.6213 67.4043 72.6213 65.4047V40.6856C72.6213 38.6866 70.9855 37.0508 68.9866 37.0508Z",
    stroke: "#1E247E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1625 41.7172L53.8359 53.935C52.1723 55.0441 49.4504 55.0441 47.7868 53.935L29 41.4111",
    stroke: "#1E247E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0684 43C54.3821 43 57.0684 40.3137 57.0684 37C57.0684 33.6863 54.3821 31 51.0684 31C47.7547 31 45.0684 33.6863 45.0684 37C45.0684 40.3137 47.7547 43 51.0684 43Z",
    fill: "#DA867D",
    stroke: "#1E247E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3104 41.245L46.8252 32.7598",
    stroke: "#1E247E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4054_7353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 101,
    height: 101,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailErrorIcon);
export default __webpack_public_path__ + "static/media/EmailErrorIcon.1f65ebc61f7f4f8445379b919da72672.svg";
export { ForwardRef as ReactComponent };